import * as React from 'react';
import * as S from '../';

type Value = Record<string, any>;

export type TListSelect = {
    type: 'list',
    name: string,
    onSelect: (x: unknown, name: string) => void,
    value?: Value | null,
    data: Value[],
    onClear?: (name: string) => void,
    placeholder?: string,
    disabled?: boolean,
}

const Component  = React.forwardRef<HTMLInputElement, TListSelect>(({
    name,
    onSelect,
    value = null,
    data,
    onClear,
    placeholder,
    disabled,
}, ref) => {
    return (
        <S.Select 
            name={name}
            onSelect={onSelect}
            onClear={onClear}>
            <S.Control disabled={disabled}>
                <S.Id>{(x) => x.icon}</S.Id>
                <S.ControlInput
                    ref={ref}
                    value={value}
                    placeholder={placeholder}
                />
            </S.Control>
            <S.Indicator />
            <S.Dropdown maxHeight={250}>
                <S.List data={data}>
                    <S.Item>{(x) => <span>{x.text as any}</span>}</S.Item>
                    <S.Error>Данных нет.</S.Error>
                </S.List>
            </S.Dropdown>
            <S.Cursor />
            <S.Setter />
            <S.Keyboard />
        </S.Select>
    );
});

export default Component;
